import React, { useState, useEffect, useCallback } from "react";

import Form from "../../components/form/admin/Usuarios/usuarios";

import { getData, sendData } from "../../helpers/auth";
import { uriList } from "../../helpers/config";
import {
  DefaultOrder,
  sortByString,
  sortByNumber,
  compareDate,
} from "../../helpers/general";
import { swalError } from "../../components/swal";

function Usuarios({ ...props }) {
  const [usuarios, setUsuarios] = useState([]);
  const [usuariosC, setUsuariosC] = useState(null);
  const [usuariosGlobal, setUsuariosGlobal] = useState(null);
  const [total, setTotal] = useState(false);
  const [actualPage, setActualPage] = useState(0);
  const [filterOptions, setFilterOptions] = useState(false);
  const [dateVisible, setDateVisible] = useState("todos");
  const [modal, setModal] = useState(false);
  const [clickedTr, setClickedTr] = useState("");
  const [ascDesc, setAscDesc] = useState(true);
  const [usuario_filter, setUsuarioFilter] = useState("");
  const [ocultarInativos, setOcultarInativos] = useState(localStorage.getItem("ocultarInativos") || "todos");
  const [master, setMaster] = useState("todos");
  const [tipo, setTipo] = useState("todos");
  const [clear, setClear] = useState(false);
  const [loaded, setLoaded] = useState(true);
  const [selecaoEmpresa_id, setSelecaoEmpresa_id] = useState(null);
  const [qtdLinesPage, setQtdLinesPage] = useState(10)
  const [totalPages, setTotalPages] = useState(0)
  const [grupoPermissoes, setGrupoPermissoes] = useState(null);

  const paginate = () => {
    if (!usuariosC) return

    console.log("Usuarios.paginate(0): ", { qtdLinesPage, actualPage })
    const startIndex = parseInt(actualPage * qtdLinesPage);
    const endIndex = parseInt(startIndex) + parseInt(qtdLinesPage);
    setUsuarios(null)

    console.log("Usuarios.paginate(1): ", { qtdUsuarios: usuariosC?.length, qtdLinesPage, actualPage, startIndex, endIndex })

    const _usuarios = usuariosC?.slice(startIndex, endIndex)
    setUsuarios(_usuarios)
  };

  // Atualizar a lista de usuários e total de páginas quando a quantidade de linhas ou a página atual mudar
  useEffect(() => {
    if (usuariosC?.length) {
      const totalPgs = Math.ceil(usuariosC?.length / qtdLinesPage);
      setTotalPages(totalPgs);
      paginate();
    }
    else
      setTotalPages(0)
  }, [qtdLinesPage, actualPage, usuariosC]);

  // Função para mudar de página
  const handleQtdLinesPage = (value) => {
    // const value = e?.currentTarget?.value
    console.log("usuarios.handleQtdLinesPage: ", value)
    setActualPage(0);
    setQtdLinesPage(value);
  }


  // useEffect(() => {
  //   getUsuarios();
  // }, [qtdLinesPage])

  const handlePage = (e) => {
    const newPage = e.currentTarget.value
    if (newPage <= totalPages) {
      setActualPage(newPage);
    }
  };

  const createFilter = (obj) => {
    let newObj = {
      nome: [],
      sigla: [],
    };

    for (let o of obj) {
      for (let i in o) {
        if (newObj[i]) {
          newObj[i].push(o[i]);
        }
      }
    }

    for (let i in newObj) {
      newObj[i] = [...new Set(newObj[i])];
    }

    setFilterOptions(newObj);
  };

  const handleSelecaoEmpresa_id = (e) => {
    setSelecaoEmpresa_id(e.currentTarget.value);
    console.log("views.handleSelecaoEmpresa_id(1): ", e.currentTarget.value)
  }

  const getGrupoPermissoes = async () => {
    try {
      const res = await sendData({
        uri: uriList("gruposPermissoes"),
        content: { status: "ATIVO" },
        method: "POST"
      });

      if (res.status && res.status > 200) throw new Error();
      console.log("views.getGrupoPermissoes(1): ", res?.data || res)
      setGrupoPermissoes(res?.data || res);
    } catch (error) {
      console.error("Erro ao buscar grupos de permissões:", error);
      setGrupoPermissoes([]);
    }
  }

  const getUsuariosC = async () => {
    console.log("views.getUsuariosC(1)")
    try {
      const res = await sendData({
        uri: uriList("usuarios"),
        content: {
          ocultarInativos: "sim"
        },
        method: "POST"
      });

      if (res.status && res.status > 200) throw new Error();
      setUsuariosC(res?.data || res);
      setUsuariosGlobal(res?.data || res);
    } catch (e) {
      console.error(e);
    }
  };

  const getUsuarios = () => {
    if (!usuario_filter && !selecaoEmpresa_id && ocultarInativos === "todos" && master === "todos" && tipo === "todos") {
      swalError("Informe ao menos um parâmetro para pesquisa");
      return;
    }

    console.log("views.getUsuarios(1)")
    setLoaded(false)

    sendData({
      uri: uriList("usuarios"),
      content: {
        ocultarInativos,
        master,
        tipo,
        empresa_id: selecaoEmpresa_id,
        usuario_filter: usuario_filter?.toUpperCase() || "",
        actualPage: actualPage + 1,
        qtdLinesPage,
        selecaoEmpresa_id: selecaoEmpresa_id?.toString() == "todos" ? null : selecaoEmpresa_id,
      },
      method: "POST"
    })
      .then((res) => {
        if (res.status && res.status > 200) throw new Error();
        let usuarios = (res?.data || res)
        console.log("views.getUsuarios(2): ", usuarios)

        setUsuariosC(null)
        setUsuarios(null)
        // setUsuariosC(_usuarios)

        // DefaultOrder(
        //   "usuarios",
        //   (usuarios)?.map((usuarios) => usuarios),
        //   setUsuarios
        // );
        setLoaded(true)
      })
      .catch((e) => {
        setLoaded(true);
        return false;
      });
  };

  useEffect(() => {
    console.log("views.usuarios.useEffect(1)");
    getUsuariosC();
    getGrupoPermissoes();
    // getUsuarios(true);
  }, [clear]);

  const sortArrObj = (key, type) => {
    console.log("views.sortArrObj(1)");
    let arr = [...usuarios];
    let asc = !ascDesc;

    arr = arr.sort((a, b) => {
      if (type === "string") {
        if (asc) {
          setAscDesc(asc);
          return sortByString(a, b, key, type);
        } else {
          setAscDesc(asc);
          return sortByString(b, a, key, type);
        }
      } else if (type === "numeric") {
        if (asc) {
          setAscDesc(asc);
          return sortByNumber(a, b, key, type);
        } else {
          setAscDesc(asc);
          return sortByNumber(b, a, key, type);
        }
      } else {
        if (asc) {
          setAscDesc(asc);
          return compareDate(new Date(a[key]), new Date(b[key])) ? 1 : -1;
        } else {
          setAscDesc(asc);
          return compareDate(new Date(b[key]), new Date(a[key])) ? 1 : -1;
        }
      }
    });

    console.log("views.sortArrObj(2): ", arr)
    setUsuarios(arr);
  };

  const handleUsuario = (e) => {
    let value = e.currentTarget.value;
    setUsuarioFilter(value);
  };

  const handleInativos = (e) => {
    let value = e.currentTarget.value;
    setOcultarInativos(value);
    localStorage.setItem("ocultarInativos", value);
  };

  const handleSelecaoEmpresa = (e) => {
    let value = e.currentTarget.value;
    // console.log("views.handleOcultarInativos(1): ", value)
    setSelecaoEmpresa_id(value);
    localStorage.setItem("setSelecaoEmpresa_id", value);
    // handleOption(e);
  };

  const handleMaster = (e) => {
    let value = e.currentTarget.value;
    setMaster(value);
  };

  const handleTipo = (e) => {
    let value = e.currentTarget.value;
    setTipo(value);
  };

  const handleClear = () => {
    setUsuarioFilter("");
    setOcultarInativos("todos");
    setMaster("todos");
    setTipo("todos");
    localStorage.setItem("ocultarInativos", 'todos');
    setUsuarios([]);

    setClear(!clear);
  };

  return (
    <>
      <Form
        filterOptions={filterOptions}
        setDateVisible={setDateVisible}
        setModal={setModal}
        setClickedTr={setClickedTr}
        clickedTr={clickedTr}
        sortArrObj={sortArrObj}
        usuarios={usuarios}
        usuariosG={usuariosGlobal}
        dateVisible={dateVisible}
        total={total}
        handlePesquisar={getUsuarios}
        getUsuarios={getUsuarios}
        context={props.context}
        handleUsuario={handleUsuario}
        usuario_filter={usuario_filter}
        handleInativos={handleInativos}
        ocultarInativos={ocultarInativos}
        tipo={tipo}
        handleTipo={handleTipo}
        master={master}
        handleMaster={handleMaster}
        handleClearOptions={handleClear}
        loaded={loaded}
        setSelecaoEmpresa_id={handleSelecaoEmpresa}
        selecaoEmpresa_id={selecaoEmpresa_id}

        actualPage={actualPage}
        handlePage={handlePage}
        qtdLinesPage={qtdLinesPage}
        handleQtdLinesPage={handleQtdLinesPage}
        totalPages={totalPages}
        grupoPermissoes={grupoPermissoes}
      />

      {modal}
    </>
  );
}

export default Usuarios;
